// @ts-nocheck

import { CardTypes } from '../../../types/card';
import LineUpYellowRedCardAsComponent from '../assets/asComponents/LineUpYellowRedCardAsComponent';
import { LineUpRedCardIconSvg, LineUpYellowCardIconSvg } from '../assets/svg';

export const CardIconsByCardType = {
  [CardTypes.YELLOW]: LineUpYellowCardIconSvg,
  [CardTypes.YELLOW_RED]: LineUpYellowRedCardAsComponent,
  [CardTypes.RED]: LineUpRedCardIconSvg,
};
